export const commonHandleStyle = {};
export const topHandleStyle = {
    ...commonHandleStyle,
    top: '0.25em',
    backgroundColor: 'red',
};
export const bottomHandleStyle = {
    ...commonHandleStyle,
    bottom: '0.25em',
    backgroundColor: 'blue',
};
export const leftHandleStyle = {
    ...commonHandleStyle,
    left: '0.25em',
    backgroundColor: 'red',
};
export const rightHandleStyle = {
    ...commonHandleStyle,
    right: '0.25em',
    backgroundColor: 'blue',
};
